import { render, staticRenderFns } from "./functionData.vue?vue&type=template&id=37f90eb4&scoped=true&"
import script from "./functionData.vue?vue&type=script&lang=js&"
export * from "./functionData.vue?vue&type=script&lang=js&"
import style0 from "./functionData.vue?vue&type=style&index=0&id=37f90eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f90eb4",
  null
  
)

export default component.exports